module.exports = __webpack_public_path__ + "img/UserInjuries.aec87446.svg";